import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ControlRegistration, Registration } from 'src/app/shared/models/registration';
import { WorkerAndToolService } from 'src/app/shared/services/worker-and-tool.service';
import { ToolbarService } from 'src/app/shared/services/toolbar.service';
import { HoursOption } from 'src/app/shared/models/hours-option';

import { alert } from 'devextreme/ui/dialog';
import { EditorPreparingEvent } from 'devextreme/ui/data_grid';
import { db } from '../../shared/models/db';

import { DxDataGridComponent } from "devextreme-angular";
import { RegistrationWorkflowService, WorkflowContext } from '../../shared/services/registration-workflow.service';

@Component({
    selector: 'app-registration-workers-hour',
    templateUrl: './registration-workers-hour.component.html',
    styleUrls: ['./registration-workers-hour.component.scss'],
    standalone: false
})

export class RegistrationWorkersHourComponent {
  registration!: Registration | undefined;
  option: HoursOption | any;

  optionSubscription: any;
  forwardSubscription: any;
  backSubscription: any;

  oreLavorateEditorOptions: object;

  hasControls = false;

  selectedControls: ControlRegistration[] = [];

  dailyHoursMap: Map<string, number> = new Map();
  maxRegistrationHours = 0;

  @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;

  constructor(
    private service: WorkerAndToolService,
    private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private router: Router,
    private workflowService: RegistrationWorkflowService) {

      this.oreLavorateEditorOptions = {
          mode: 'number',
          showSpinButtons: false
      }

    this.registration = service.getNewRegistration();
 }

    ngOnInit() {
      this.optionSubscription = this.service.getHoursOptionObservable().subscribe(val => {
        this.option = val;
        this.tryLoadDailyHours();
      });

      this.backSubscription = this.toolbar.backClickedEvent.subscribe(()=>this.Back());
      this.forwardSubscription = this.toolbar.forwardClickedEvent.subscribe(()=>this.Forward());

      this.toolbar.BackVisibleChanged(true);
      this.toolbar.SaveVisibleChanged(false);
      this.toolbar.ForwardVisibleChanged(true);
      this.toolbar.CancelVisibleChanged(false);
      this.toolbar.PlusVisibleChanged(false);
      this.toolbar.EditVisibleChanged(false);
      this.toolbar.DeleteVisibleChanged(false);
      this.toolbar.CopyVisibleChanged(false);
      this.toolbar.MenuVisibleChanged(false);

      let regId = this.route.snapshot.paramMap.get('id');

      if (regId == null) {
        regId = "-1";
      }

      this.service.getTempRegistration(Number(regId)).then((reg) => {
        this.registration = reg;

        if (this.registration) {
          this.service.getHasControls(this.registration).then(c => { this.hasControls = c; });
          this.tryLoadDailyHours();
        }

      });
      

    }

    ngOnDestroy() {
      this.optionSubscription.unsubscribe()
      this.backSubscription.unsubscribe();
      this.forwardSubscription.unsubscribe();
    }


    verificaOreNegative(e: { value: number; }) {
      return e.value >= 0;
    }

    verificaOreAZero(e: { value: number; }) {
      return e.value != 0;
    }

    verificaOreOltreGiornata(e: { value: number; }) {
      return e.value < 24;
    }

    verificaFrazioni(e: { value: number; }) {
      return (e.value * 40 % 10) == 0;
    }

    onEditorPreparing(e: EditorPreparingEvent) {
      if (e.dataField === "oreLavorate" && e.parentType === "dataRow") {
          e.editorOptions.onFocusIn = (function (args: { element: { querySelector: (arg0: string) => { (): any; new(): any; select: { (): void; new(): any; }; }; }; }): void {
            console.log(args.element);
            args.element.querySelector(".dx-texteditor-input").select();
          })
      }
    }

  Forward() {
    this.grid.instance.saveEditData().then(() => this.saveRegistration());
  }

  private saveRegistration() {

    if (this.registration) {

      this.registration.workerRegistrations = this.registration.workerRegistrations.filter(x => x.oreLavorate > 0);

      // Validazione MaxRegistrationHours
      if (this.maxRegistrationHours > 0) {
        const newHoursPerWorker = new Map<string, number>();
        this.registration.workerRegistrations.forEach(wr => {
          const current = newHoursPerWorker.get(wr.workerNumber) ?? 0;
          newHoursPerWorker.set(wr.workerNumber, current + wr.oreLavorate);
        });

        const overLimitWorkers: string[] = [];
        newHoursPerWorker.forEach((newHours, workerNumber) => {
          const previousHours = this.dailyHoursMap.get(workerNumber) ?? 0;
          if (previousHours + newHours > this.maxRegistrationHours) {
            const wr = this.registration!.workerRegistrations.find(w => w.workerNumber === workerNumber);
            overLimitWorkers.push(
              `${wr?.workerDescription ?? workerNumber}: ${previousHours} + ${newHours} = ${previousHours + newHours} (max: ${this.maxRegistrationHours})`
            );
          }
        });

        if (overLimitWorkers.length > 0) {
          alert('I seguenti dipendenti superano il limite di ore giornaliere:<br>' + overLimitWorkers.join('<br>'), 'Errore');
          return;
        }
      }

      const ctx: WorkflowContext = { options: this.option, siteManagerMode: true, hasControls: this.hasControls };

      if (this.workflowService.isFinalStep('registration-worker-hour', ctx)) {
        this.registration.id ??= 0;
        if (this.registration.id > 0) {
          this.service.editRegistration(this.registration, this.registration.id)
            .then(() => this.router.navigate(['/registrations']));
        } else {
          this.service.addRegistration(this.registration)
            .then(() => this.router.navigate(['/registrations']));
        }
      } else {
        this.service.editTempRegistration(this.registration, this.registration.id ?? 0)
          .then((regId) => {
            const next = this.workflowService.getNextStep('registration-worker-hour', ctx);
            this.router.navigate(['/' + next, { id: regId }]);
          });
      }
    }
    else {
      alert("Nessuna registrazione individuata", "Errore");
    }
  }
  


    private tryLoadDailyHours() {
      if (!this.registration || !this.option || this.dailyHoursMap.size > 0) return;
      if (this.option.maxRegistrationHours && this.option.maxRegistrationHours > 0) {
        this.maxRegistrationHours = this.option.maxRegistrationHours;
        const date = this.registration.dataRegistrazioneString;
        const excludeId = this.registration.id && this.registration.id > 0 ? this.registration.id : undefined;
        Promise.all([
          this.service.getWorkerDailyHoursForDate(date),
          this.service.getUnsyncedWorkerHoursForDate(date, excludeId)
        ]).then(([syncedHours, unsyncedHours]) => {
          syncedHours.forEach(h => this.dailyHoursMap.set(h.workerNumber, h.totalHours));
          unsyncedHours.forEach((hours, workerNumber) => {
            const current = this.dailyHoursMap.get(workerNumber) ?? 0;
            this.dailyHoursMap.set(workerNumber, current + hours);
          });
        });
      }
    }

    Back()
    {
      this.router.navigate(['/registration-worker-select', { id: this.registration?.id }]);
    }
}
